export default function guestNeedHelpDetailsMiddleware(to, from, next) {
    const guestData = JSON.parse(localStorage.getItem('guest_data'));
    if (guestData &&
        guestData.guest.guest_need_help_flight.length > 0) {
        next();
    } else {
        next('/error');
    }
}